import { FormEmails } from "@/model/FormEmails";

export interface StateFormEmail {
  formEmail: FormEmails;
  formEmailStatusSave: StateSaveFormEmail;
}

export enum StateSaveFormEmail {
  initial,
  loading,
  success,
  fail,
}
